<div class="seccion-media">
  <h2>Objetos Personales </h2>
  <p>
    Somos una editorial independiente con sede en Buenos Aires que se propone difundir el trabajo de escritores y artistas contemporáneos. Publicamos ensayo literario, crónica y más. Nos interesan los textos levemente distraídos del eje de los géneros, dispuestos a abrirse a la rareza y a exponerse en los vaivenes del hacer.
  </p>
  <h2>Hacemos Objetos Personales</h2>
  <ul class="librerias">
    <li>
      <h3>Dirección editorial</h3>
      <span>María Stegmayer</span>
    </li>
    <li>
      <h3>Concepto y diseño inicial</h3>
      <span>Agustina Stegmayer</span>
    </li>
    <li>
      <h3>Diseño y maquetación</h3>
      <span>Veronique Pestoni</span>
    </li>
    <li>
      <h3>Desarrollo web</h3>
      <span>Manuel Rodríguez Schiller</span>
    </li>
  </ul>

</div>